import { ApiService } from "../..";

export const fetchUserProfile = (userId: string) => {
  return ApiService.baseAction("user/profile/" + userId, {}, "get");
};
